import { render, staticRenderFns } from "./ReturnArticleToStock.vue?vue&type=template&id=7f3fe370&scoped=true"
import script from "./ReturnArticleToStock.vue?vue&type=script&lang=js"
export * from "./ReturnArticleToStock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f3fe370",
  null
  
)

export default component.exports